import { Form as FormikForm } from "formik"

import {
    L2RButton,
    HierarchicalList as UIHierarchicalList,
    FormikTextField,
    FormikSelect,
    Skeleton,
    TagsAutocomplete as L2RTagsAutocomplete,
    Typography,
    styled,
} from "@l2r-front/l2r-ui"

export const Form = styled(FormikForm)(() => ({
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
    minHeight: 0,
}))

export const FormContent = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
    flex: "1 1 0",
    overflowY: "auto",
    paddingTop: theme.spacing(2),
}))

export const Desc = styled(Typography)(() => ({
}))

interface MapContainerProps {
    height: string | number;
}

export const MapContainer = styled("div", { shouldForwardProp: prop => prop !== "height" })<MapContainerProps>(({ theme, height }) => ({
    borderRadius: theme.spacing(3),
    height: height,
    marginBottom: theme.spacing(8),
    flexShrink: 0,
}))

export const Select = styled(FormikSelect)(() => ({
    width: "100%",
    height: "auto",
}))

export const TextField = styled(FormikTextField)(() => ({
    width: "100%",
}))

export const SubmitButton = styled(L2RButton)(({ theme }) => ({
    marginLeft: theme.spacing(2),
    textTransform: "capitalize",
}))

export const HierarchicalList = styled(UIHierarchicalList)({
    flex: "1 1 auto",
    minHeight: 0,
})


export const FormSkeleton = styled(Skeleton)(() => ({
    transform: "none",
}))

export const ErrorMessage = styled(Typography)(({ theme }) => ({
    color: theme.palette["error"].main,
}))

export const TagsAutocomplete = styled(L2RTagsAutocomplete)(({ theme }) => ({
    marginBottom: theme.spacing(3),
}))